import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getLocalityList, updateLocality } from "../../Redux/Actions/localityAction";
import "./listLocality.css";
import { columnsLocality } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListLocality = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const { localityList, listLoading } = useSelector((state) => state.locality);
    const LocalityData = localityList
    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
        const localityData = {
            page,
            limit: pageSize,
            is_deleted: false,
            filter: debouncedSearch,
            ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
            ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
        };

        try {
            await dispatch(getLocalityList(localityData, showLoader));

            if (!showLoader) {
                toast.success("Locality list refreshed");
            }
        } catch {
            if (!showLoader) {
                toast.error("Failed to refresh Locality list");
            }
        }
    },
        [dispatch, debouncedSearch, dateRange]
    );

    const handleStatusChange = async (record, action) => {
        let payload = { id: record._id };
        payload.status = action;

        await dispatch(updateLocality(payload.id, payload));
        fetchDetails(pagination.current, pagination.pageSize);
    };

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchDetails, pagination.current, pagination.pageSize]);


    useEffect(() => {
        if (LocalityData?.total) {
            setPagination((prevData) => ({ ...prevData, total: LocalityData.total }));
        }
    }, [LocalityData]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    useEffect(() => {
        setPagination((prev) => ({ ...prev, current: 1 }));
    }, [debouncedSearch]);

    return (
        <MainLayout>
            <div className="dashboard-container">
                <div className="table_component_all">
                    <ListTopSearch
                        h3heading="Locality List"
                        setState={setSearchQuery}
                        buttonhead2={canAdd ? "Add Locality" : null}
                        navigateTo2={canAdd ? "/locality/add" : null}
                        // filterFunction={filterHandler}
                        onCalendarClick={() => setIsDatePopupVisible(true)}
                    >
                        <div
                            style={{
                                position: "static",
                                marginTop: "-70px",
                                marginLeft: "81%",
                                marginBottom: "24px",
                            }}
                        >
                        </div>
                    </ListTopSearch>
                    <div style={{ overflowX: "auto", padding: "0px 60px" }}>
                        <Table
                            dataSource={Array.isArray(LocalityData?.data) ? LocalityData.data : []}
                            pagination={pagination}
                            onChange={handleTableChange}
                            loading={listLoading}
                            columns={columnsLocality(pagination.current, pagination.pageSize, handleStatusChange, canEdit)}
                        ></Table>
                    </div>
                </div>
                <DateRangePopup
                    visible={isDatePopupVisible}
                    initialStart={dateRange.start}
                    initialEnd={dateRange.end}
                    onCancel={() => setIsDatePopupVisible(false)}
                    onOk={handleDateRangeApply}
                />
            </div>
        </MainLayout>
    );
};

export default ListLocality;
